const HERO_EDGE_TOLERANCE = 8;

class HeroCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-hero-track]');
    this.prev = this.querySelector('[data-hero-prev]');
    this.next = this.querySelector('[data-hero-next]');
    if (!this.track) return;

    this.prev?.addEventListener('click', () => this.advance(-1));
    this.next?.addEventListener('click', () => this.advance(1));
    this.track.addEventListener('scroll', () => this.syncButtons(), { passive: true });
    window.addEventListener('resize', () => this.syncButtons());

    this.syncButtons();
  }

  get step() {
    const card = this.track.querySelector('li');
    if (!card) return this.track.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  get maxScroll() {
    return this.track.scrollWidth - this.track.clientWidth;
  }

  advance(direction) {
    // Scroll to an absolute target rather than scrollBy: with mandatory snap a
    // partial delta can be snapped straight back to where it started.
    const target = Math.max(0, Math.min(this.maxScroll, this.track.scrollLeft + this.step * direction));
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollTo({ left: target, behavior: reduced ? 'auto' : 'smooth' });
  }

  syncButtons() {
    const x = this.track.scrollLeft;
    if (this.prev) this.prev.disabled = x <= HERO_EDGE_TOLERANCE;
    if (this.next) this.next.disabled = x >= this.maxScroll - HERO_EDGE_TOLERANCE;
  }
}

if (!customElements.get('hero-carousel')) {
  customElements.define('hero-carousel', HeroCarousel);
}
